export type FilterDateRangeFieldName = "checkDateRange" | "invoiceDateRange";

export interface FilterDateRangeSelectorProps {
  button?: {
    size?: "small" | "medium";
    shape?: "pill" | "rounded" | null;
    color?: "grey" | "primary" | "secondary" | "error" | "warning" | "success";
  },
  className?: string;
  value: string | null;
  fieldName: FilterDateRangeFieldName;
  onChange: (value: FilterDateRange | null) => void;
}

export enum FilterDateRange {
  THIS_MONTH = "0",
  LAST_1_MONTH = "1",
  LAST_3_MONTHS = "3",
  LAST_6_MONTHS = "6",
  LAST_12_MONTHS = "12",
}

export const DATE_RANGE_LIST = [
  { value: FilterDateRange.THIS_MONTH, key: FilterDateRange.THIS_MONTH, label: "This month" },
  { value: FilterDateRange.LAST_1_MONTH, key: FilterDateRange.LAST_1_MONTH, label: "Last 1 month" },
  { value: FilterDateRange.LAST_3_MONTHS, key: FilterDateRange.LAST_3_MONTHS, label: "Last 3 months" },
  { value: FilterDateRange.LAST_6_MONTHS, key: FilterDateRange.LAST_6_MONTHS, label: "Last 6 months" },
  { value: FilterDateRange.LAST_12_MONTHS, key: FilterDateRange.LAST_12_MONTHS, label: "Last 12 months" },
];
